import { CircularProgress } from "@mui/material";

export function Loading() {
	return (
		<div className="flex justify-center items-center w-full h-[60vh]">
			<CircularProgress color="primary" />
		</div>
	);
}
